var r = Array.isArray, a = r;
export {
  a as i
};
//# sourceMappingURL=index.es265.js.map
